import {
  Alert,
  Avatar,
  CardHeader,
  Table,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { AnalysisPopover } from "../AnalysisPopover/AnalysisPopover";
import { useState } from "react";
import { DataLoadingRow } from "../ListTable/DataLoadingRow";
import {
  SeverityRow,
  PackageAnalysisAggregateLineItem,
} from "@interfaces/analysis";
import { SocialCommitmentTypeSpend } from "@interfaces/commitment";
import { getSeverityColour } from "@utils/color";
import { reportStatusToColor } from "@interfaces/contractorReport";
import { LegendPopover } from "../LegendPopover/LegendPopover";

interface ContractorAnalyticsLabourSpendProps {
  analysis: PackageAnalysisAggregateLineItem[];
}
export const ContractorAnalyticsLabourSpend = ({
  analysis,
}: ContractorAnalyticsLabourSpendProps) => {
  const [legendAnchorElement, setLegendAnchorElement] = useState<
    Element | undefined
  >(undefined);
  const [anchorElement, setAnchorElement] = useState<Element | undefined>(
    undefined
  );
  const [severityRow, setSeverityRow] = useState<SeverityRow | undefined>(
    undefined
  );

  const onLeaveLegend = () => {
    console.log("On leave");
    setLegendAnchorElement(undefined);
  };
  const onEnterLegend = (event: any) => {
    console.log("On enter");
    setLegendAnchorElement(event.target);
  };

  const onLeave = () => {
    console.log("On leave");
    setSeverityRow(undefined);
    setAnchorElement(undefined);
  };
  const onEnter = (event: any, selectedSeverityRow: SeverityRow) => {
    console.log("On enter");
    setAnchorElement(event.target);
    setSeverityRow(selectedSeverityRow);
  };
  const loading = false;

  const getSeverity = (
    item: PackageAnalysisAggregateLineItem,
    commitmentType: SocialCommitmentTypeSpend
  ): SeverityRow => {
    const total = 0;
    const totalTarget = 0;
    const pcChange = 0;
    // switch (commitmentType) {
    //   default:
    //     break;
    //   case SocialCommitmentTypeSpend.LocalContent:
    //     total = item.localSpend.achieved;
    //     totalTarget = item.localSpend.target;
    //     pcChange = item.localSpend.pcChange;
    //     break;
    //   case SocialCommitmentTypeSpend.AboriginalTorresStraitIslanderBusinessSpend:
    //     total = item.indigSpend.achieved;
    //     totalTarget = item.indigSpend.target;
    //     pcChange = item.indigSpend.pcChange;
    //     break;
    //   case SocialCommitmentTypeSpend.SocialDisabilityEnterpriseSpend:
    //     total = item.disSocSpend.achieved;
    //     totalTarget = item.disSocSpend.target;
    //     pcChange = item.disSocSpend.pcChange;

    //     break;
    // }

    let ratio = 0;
    if (totalTarget > 0) {
      ratio = total / totalTarget;
    }
    const severity = getSeverityColour(ratio);
    return {
      severity,
      total,
      totalTarget,
      pcChange,
      ratio,
      label: `${(ratio * 100).toLocaleString()}%`,
    };
  };

  return (
    <>
      <Table style={{ tableLayout: "fixed" }}>
        <TableHead>
          <TableCell>Package No.</TableCell>
          <TableCell>Subcontractor</TableCell>
          <TableCell>Report Submitted</TableCell>
          <TableCell>LIPD</TableCell>
          <TableCell>Social Enterprise</TableCell>
          <TableCell>Indigenous Spend</TableCell>
        </TableHead>
        {!loading && analysis
          ? analysis?.map((p, index) => {
              const dataLc = getSeverity(
                p,
                SocialCommitmentTypeSpend.LocalContent
              );
              const dataDis = getSeverity(
                p,
                SocialCommitmentTypeSpend.SocialDisabilityEnterpriseSpend
              );
              const dataIndi = getSeverity(
                p,
                SocialCommitmentTypeSpend.AboriginalTorresStraitIslanderBusinessSpend
              );
              return (
                <TableRow>
                  <TableCell>{`#${index + 1}`}</TableCell>
                  <TableCell>
                    <Tooltip title={p.contractorName}>
                      <CardHeader
                        avatar={
                          <Avatar
                            src={p.contractorLogo}
                            alt={
                              p.contractorName.length > 0
                                ? p.contractorName[0].toUpperCase()
                                : "Unknown"
                            }
                          />
                        }
                        title={""}
                      />
                    </Tooltip>
                  </TableCell>
                  <TableCell
                    onMouseEnter={onEnterLegend}
                    onMouseLeave={onLeaveLegend}
                  >
                    <Alert
                      variant="filled"
                      severity={reportStatusToColor(p.reportStatus)}
                      sx={{
                        margin: "auto !important",
                        "& .MuiAlert-icon": { margin: "auto important!" },
                      }}
                    ></Alert>
                  </TableCell>
                  <TableCell
                    onMouseEnter={(event: any) => onEnter(event, dataLc)}
                    onMouseLeave={onLeave}
                  >
                    <Alert variant="filled" severity={dataLc.severity}>
                      {dataLc.label}
                    </Alert>
                  </TableCell>
                  <TableCell
                    onMouseEnter={(event: any) => onEnter(event, dataDis)}
                    onMouseLeave={onLeave}
                  >
                    <Alert variant="filled" severity={dataDis.severity}>
                      {dataDis.label}
                    </Alert>
                  </TableCell>
                  <TableCell
                    onMouseEnter={(event: any) => onEnter(event, dataIndi)}
                    onMouseLeave={onLeave}
                  >
                    <Alert variant="filled" severity={dataIndi.severity}>
                      {dataIndi.label}
                    </Alert>
                  </TableCell>
                </TableRow>
              );
            })
          : null}

        {analysis && analysis?.length === 0 && !loading ? (
          <TableRow>
            <TableCell align="center" colSpan={9} sx={{ py: 3 }}>
              <Typography paragraph>No Packages</Typography>
            </TableCell>
          </TableRow>
        ) : null}
        {loading ? <DataLoadingRow colSpan={9} /> : null}
      </Table>

      {severityRow ? (
        <AnalysisPopover
          severityRow={severityRow}
          anchorElement={anchorElement}
          handleCloseMenu={function (): void {
            setAnchorElement(undefined);
          }}
        />
      ) : null}
      {legendAnchorElement ? (
        <LegendPopover
          anchorElement={legendAnchorElement}
          handleCloseMenu={function (): void {
            setLegendAnchorElement(undefined);
          }}
        />
      ) : null}
    </>
  );
};
